import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../constant/routes';

const WalletPage = () => {
  return <Navigate replace to={ROUTES.WALLET.DEPOSIT} />;
};

export default WalletPage;
